const arcSymposiumConfig = {
  // Arc CFP window — update these dates once confirmed with the team
  cfpStarts: '2026-05-01T09:00:00-06:00', // TODO: confirm with team
  submissionEnds: '2026-06-29T23:59:59-06:00', // TODO: confirm with team
  approvalStarts: '2026-09-15T12:59:59-06:00', // TODO: confirm with team
  sessionsDue: '2026-12-08T23:59:59-07:00', // TODO: confirm with team
  // Arc Symposium event — Wednesday before RootsTech
  starts: '2027-03-03T09:00:00-07:00', // TODO: confirm with team
  ends: '2027-03-03T17:00:00-07:00', // TODO: confirm with team
}

export default arcSymposiumConfig
